import React, { useContext, useEffect } from "react";
import Typography from "@mui/material/Typography";
import { Grid } from "@mui/material";
import MyContext from "../../../StoreContext";
import AutoResponse from "../AutoResponse/AutoResponse";
import Derive from "../AutoResponse/Derive";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import PlatformModal from "./PlatformModal";
import { styled } from "@mui/material/styles";
import freshdesk from "./assets/freshdesk.svg";
import zendesk from "./assets/zendesk.svg";
import salesforce from "./assets/salesforce.svg";
import stepFour from "./assets/stepFour.svg";
import { trackHotjar } from "../../../helpers/hotjar";

const CustomButton = styled(Button)`
  width: 220px;
  border-radius: 10px;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.16);
  height: 40px;
  background-color: #f6fbfe;
  border: none;

  &.Mui-disabled {
    opacity: 0.5;
    cursor: no-drop;
  }
`;

const buttonText = {
  fontSize: "16px",
  fontWeight: "600",
  fontFamily: "Asap",
  color: "#000000",
  lineHeight: "20px",
};

const containerMargin = {
  marginTop: "24px",
};

const spaceBetween = {
  gap: "16px",
  marginBottom: "40px",
};

/**
 * En este componente se muestran las respuestas automaticas
 * junto con si la respuesta es derivada o no, ademas agregamos la
 * logica para mostrar los botones con las plataformas en las que
 * se llama a un modal con la imagen necesaria segun sea el caso
 * Este es el cuarto y ultimo paso del flujo de la automatizacion
 */
const Platforms = () => {
  const {
    showPlatform,
    message,
    updatePlatform,
    updateShowResponse,
    updateOpenModal,
  } = useContext(MyContext);

  useEffect(() => {
    const timer = setTimeout(() => {
      updateShowResponse(true);
      console.log("plarform response ");
    }, 2000);
    return () => {
      clearTimeout(timer);
      updateShowResponse(false);
      console.log("plarform response salida");
    };
  }, [showPlatform]);

  const handleModal = (e: React.MouseEvent<HTMLButtonElement>) => {
    trackHotjar(`[Etapa 4] Ha seleccionado ${e.currentTarget.name}`);
    updateOpenModal(true);
    updatePlatform(e.currentTarget.name);
  };

  // Si el mensaje es alguno de estos tres no se debe mostrar el modal ya que el caso
  // es un derivado que sera atendido por un agente
  const deriveResponse =
    message === "stolen" || message === "consult" || message === "order";

  return (
    <>
      <Grid container flexDirection='column' sx={spaceBetween}>
        <Grid container>
          <img src={stepFour} alt='stepFour' />
        </Grid>
        <Stack direction='column' spacing={2}>
          <CustomButton
            variant='outlined'
            onClick={handleModal}
            name={"freshdesk"}
            disabled={deriveResponse}
          >
            <img src={freshdesk} alt='freshdesk' />
            <Typography
              sx={buttonText}
              style={{ marginLeft: "5px" }}
              className='toggleMessageButtonText'
            >
              freshdesk
            </Typography>
          </CustomButton>
          <CustomButton
            variant='outlined'
            onClick={handleModal}
            name={"salesforce"}
            disabled={deriveResponse}
          >
            <img src={salesforce} alt='salesforce' />
            <Typography
              sx={buttonText}
              style={{ marginLeft: "5px" }}
              className='toggleMessageButtonText'
            >
              salesforce
            </Typography>
          </CustomButton>
          <CustomButton
            variant='outlined'
            onClick={handleModal}
            name={"zendesk"}
            disabled={deriveResponse}
          >
            <img src={zendesk} alt='zendesk' />
            <Typography sx={buttonText} className='toggleMessageButtonText'>
              zendesk
            </Typography>
          </CustomButton>
        </Stack>
      </Grid>
      <Grid container sx={containerMargin}>
        <AutoResponse />
      </Grid>
      <Grid container sx={containerMargin}>
        <Derive />
      </Grid>
      <PlatformModal />
    </>
  );
};

export default Platforms;
